import BaseBehavior from '../../../framework/base/base';
import { hideElement } from '../../../shared/utilities/show-hide';

export default class VideoPoster extends BaseBehavior {
	constructor(element) {
		super(element);
		const videoPoster = element.querySelector('.v2-video-component__poster video');

		if (videoPoster) {
			videoPoster.onloadeddata = () => {
				const pictureElem = element.querySelector('.v2-video-component__poster picture');
				element.classList.add('v2-bg--black');
				if (pictureElem) {
					hideElement(pictureElem);
				}
			};
		}
	}
}
